/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateCardInstrumentRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UpdateCardInstrument.pb'
import {UpdateCardInstrumentResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UpdateCardInstrument.pb'


export const updateCardInstrument = (request:UpdateCardInstrumentRequest, options?: CashRequestOptions) => post<UpdateCardInstrumentRequest, UpdateCardInstrumentResponse>("/2.0/cash/update-card-instrument", request, {...options, rejectOnError: true })